<template>
  <div id="header" class="flex flex1 justify-center items-center">
    <div class="header__body flex justify-between items-center row">
      <div>
        <img :src="IMAGE_LOGO" alt="AlphaBIM二维码管理" />
      </div>
      <div>
        <el-button
          v-if="ROUTER_PATH.name === 'Main'"
          :size="size"
          plain
          type="primary"
          @click="onRouteChange('Login')"
        >
          登录
        </el-button>
        <el-button
          v-if="ROUTER_PATH.name !== 'Main'"
          :size="size"
          plain
          type="info"
          @click="onRouteChange('Main')"
        >
          产品首页
        </el-button>
        <el-button :size="size" plain type="info">
          应用场景
        </el-button>
        <el-button :size="size" plain type="info">
          产品模板
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'Header',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      size: 'mini',
      IMAGE_LOGO: require('@/assets/images/bg/logo.svg'),
    }
  },
  computed: {
    ...mapState({
      ROUTER_PATH: state => state.ROUTER_PATH,
    }),
  },
  watch: {},
  created() {},
  mounted() {},
  destroy() {},
  methods: {
    // ...mapMutations('', []),
    onRouteChange(name) {
      this.$store.commit('setRouter', {
        name,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#header {
  position: fixed;
  z-index: 999999990;
  top: 0;
  width: 100vw;
  height: 50px;
  background: rgba(47, 89, 130, 0.5);

  .header__body {
    width: 60%;
  }
}
</style>
<style lang="scss"></style>
